import './LoginHeader.scss';
import Component from './LoginHeader.js';
export default Component;
